import { TextField, PhoneNumberField } from "@apac/form-ui";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Page } from "@tenant/ui";
import clsx from "clsx";
import { ErrorModal } from "../ErrorModal";
import { useOnboardingForm } from "./hooks";
import styles from "./styles.module.scss";

export const NewUserOnboarding: React.FC<PlatformComponentProps> = ({
  className,
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "NewUserOnboarding");

  const {
    formContext,
    errorMessage,
    handlers: { onSubmit, clearErrorMessage },
  } = useOnboardingForm();

  return (
    <Page
      className={clsx(block, className)}
      title={t("header.accountCreation")}
      footer={<></>}
    >
      <div className={cn("container")}>
        <div className={cn("header")}>
          <div className={cn("title")}>{t("onboarding.accountDetails")}</div>
          <div className={cn("subtitle")}>
            {t("onboarding.accountDetailsSubtitle")}
          </div>
        </div>

        <form
          className={cn("form")}
          onSubmit={formContext.handleSubmit(onSubmit)}
        >
          <PhoneNumberField
            formContext={formContext}
            label={t("phoneNumber")}
          />

          <TextField
            formContext={formContext}
            name={"email"}
            label={t("email")}
          />
          <TextField
            formContext={formContext}
            name={"firstName"}
            label={t("firstName")}
          />
          <TextField
            formContext={formContext}
            name={"lastName"}
            label={t("lastName")}
          />

          <div className={cn("bottom-floating-root")}>
            <button type="submit" className={cn("continue-button")}>
              {t("continue")}
            </button>
          </div>
        </form>
      </div>

      <ErrorModal
        open={errorMessage != null}
        title={errorMessage ?? ""}
        subtitle={""}
        primaryButtonText={t("tryAgain")}
        primaryOnClick={clearErrorMessage}
        onClose={clearErrorMessage}
      />
    </Page>
  );
};
